import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import api from "../assets/api.png";
import css from "../assets/css.png";
import git from "../assets/git.png";
import html from "../assets/html.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import typescript from "../assets/typescript.png";
import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about03 from "../assets/about03.png";
import about04 from "../assets/about04.png";
import circle from "../assets/circle.svg";

import santosh from "../assets/santosh.jpg";
const chakra =
  "https://th.bing.com/th/id/OIP.DNOiZZYIxgQJI35MjyJQTwAAAA?w=119&h=128&c=7&r=0&o=5&pid=1.7";

export default {
  email,
  mobile,
  api,
  css,
  chakra,
  git,
  html,
  javascript,
  node,
  react,
  redux,
  typescript,
  about01,
  about02,
  about03,
  about04,
  circle,
  // logo,
  santosh,
};
